import { NavigationCombined } from './type';

export const crude = (internal: boolean, urlPrefix = ''): NavigationCombined => {
  return {
    order: 0,
    app: 'crude',
    label: 'Crude',
    icon: 'oil_barrel',
    flat: false,
    prefix: 'crude',
    title: 'Crude',
    children: [
      {
        label: 'Capture',
        link: !internal ? `${urlPrefix}/crude/capture` : null,
        route: internal ? ['/', 'capture'] : null,
        icon: 'insert_drive_file',
      },
      {
        label: 'Wetlist',
        link: !internal ? `${urlPrefix}/crude/wetlist` : null,
        route: internal ? ['/', 'wetlist'] : null,
        icon: 'local_printshop',
        disabled: false,
      },
    ],
  };
};
